import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { VoiceDetailsCard } from "@/components/atoms/interactionDetailsCard";
import { InteractionActionCard } from "@/components/molecules/interactionActionCard";
import { Call20Regular } from "@fluentui/react-icons";
import {
	CallSessionState,
	useCallSessionStore,
} from "@/common/stores/nonpersistingStores/callSession";
import PlaySoundHelper, { SoundType } from "@/common/helpers/play-sound-helper";
import {
	getRingingFilePath,
	ringingFilePathQueryKey,
} from "@/repository/queryFns/utils";

import { useQuery } from "@tanstack/react-query";
import { useAcs } from "@/common/acs/AcsContext";

export const VoiceUnifyInteractionCard = () => {
	const intl = useIntl();
	const [audioFile, setAudioFile] = useState<HTMLAudioElement | undefined>(
		undefined
	);

	const { incomingCall, answerCall, rejectCall } = useAcs();

	const callSession = useCallSessionStore(
		(state: CallSessionState) => state.callSession
	);

	const { data: ringingFilePath } = useQuery<string>({
		queryKey: [ringingFilePathQueryKey, true],
		queryFn: () => getRingingFilePath(true),
	});

	useEffect(() => {
		if (incomingCall) {
			if (ringingFilePath) {
				const offeringAudioFile = PlaySoundHelper.playSound(
					SoundType.Ringing,
					ringingFilePath,
					true
				);

				if (offeringAudioFile) {
					setAudioFile(offeringAudioFile);
				}
			}
		} else {
			if (audioFile) {
				audioFile.pause();
			}
		}
	}, [incomingCall, ringingFilePath]);

	useEffect(() => {
		if (!incomingCall) {
			stopOfferingInteraction();
		}
	}, [incomingCall]);

	useEffect(() => {
		return () => {
			stopOfferingInteraction();
		}
	}, []);

	const stopOfferingInteraction = () => {
		PlaySoundHelper.stopPlayingLoop();
	};

	return (
		incomingCall && (
			<>
				{callSession && (
					<VoiceDetailsCard
						contactName={callSession?.caller?.name}
						contactInfo={callSession?.caller?.contactInformation}
						queueName={callSession?.queueName}
						skills={callSession?.skills}
						isNextToInternalToaster={true}
						offeringVariableText={callSession?.offeringVariableText}
					offeringVariableTextIsAiGenerated={callSession?.offeringVariableTextIsAiGenerated}
					/>
				)}

				<InteractionActionCard
					contactName={
						callSession?.caller?.name ?? incomingCall?.callerInfo.displayName
					}
					icon={<Call20Regular />}
					message={intl.formatMessage({
						id: "Interaction.Contents.CallMessage",
					})}
					acceptInteraction={answerCall}
					rejectInteraction={rejectCall}
				/>
			</>
		)
	);
};
